import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { GridFilterModel, GridRowId, GridSortModel } from "@mui/x-data-grid-pro";
import { GridColumnDef, GridColumnVisibilityMap } from "../../components/grids/grid";

export interface AddressState {
    currentPage: number;
    pageSize: number;
    filterModel: GridFilterModel;
    selectionModel: Array<GridRowId>;
    sortModel: GridSortModel;
    columnDef: GridColumnDef[];
    columnVisibility: GridColumnVisibilityMap;
}

const initialState: AddressState = {
    currentPage: 0,
    pageSize: 100,
    filterModel: {items: []},
    selectionModel: [],
    sortModel: [],
    columnDef: [
        {field: 'id'},
        {field: 'edit'},
        {field: 'remove'},
        {field: 'description'},
        {field: 'contact'},
        {field: 'line1'},
        {field: 'line2'},
        {field: 'line3'},
        {field: 'phone'},
    ],
    columnVisibility: {
        id: false,
    }
}

export const addressSlice = createSlice({
    name: 'address',
    initialState,
    reducers: {
        setCurrentPage: (state, action: PayloadAction<number>) => {
            state.currentPage = action.payload;
        },

        setPageSize: (state, action: PayloadAction<number>) => {
            state.pageSize = action.payload;
        },

        setSelectionModel: (state, action: PayloadAction<Array<GridRowId>>) => {
            state.selectionModel = action.payload;
        },

        setFilterModel: (state, action: PayloadAction<GridFilterModel>) => {
            state.filterModel = action.payload;
        },

        setSortModel: (state, action: PayloadAction<GridSortModel>) => {
            state.sortModel = action.payload;
        },

        setColumnDef: (state, action: PayloadAction<GridColumnDef[]>) => {
            state.columnDef = action.payload;
        },

        setColumnVisibility: (state, action: PayloadAction<GridColumnVisibilityMap>) => {
            state.columnVisibility = action.payload;
        }
    },
})

export const {
    setCurrentPage,
    setPageSize,
    setFilterModel,
    setSelectionModel,
    setSortModel,
    setColumnDef,
    setColumnVisibility,
} = addressSlice.actions

export default addressSlice.reducer
